import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl, Tabs, Tab, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import MaskedInput from '../components/MaskedInput';
import MaskedText from '../components/MaskedText';
import ProgramDetailPage from './ProgramDetailPage';
import ProgramGoalPage from './ProgramGoalPage';
import ErrorComponent from '../components/ErrorComponent';
import { Checkbox } from 'react-bootstrap';
import InfoBox from '../components/InfoBox';

export default class ProgramGoalPageCustomerResult extends PageComponent {
  static PageInfo = {
    path: "/Program/Detail/:id/Goal/:goal/CustomerResult",
    parent: ProgramGoalPage,
    name: "menu.result",
    permission: { "GOAL_ACCESS": true },
    icon: "money-bill-wave",
    hidden: true
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.isModalVisible = null;
    this.state.modalError = null;
    this.state.changed = false;
    this.state.form = null;
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/ProgramResultsDetails")
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            console.log(data)
            this.setState({ data: data, loading: false, status: data.programResults?.programResultsStatus[0]});
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  openModal(target, props) {
    var v = {};
    props = typeof props === "object" && props != null ? props : {};
    props.isModalVisible = target;
    props.modalInitializing = false;
    props.modalLoading = false;
    props.selectedUser = null;
    props.users = null;
    props.form = {}
    props.modalError = null;
    this.setState(props);
  }

  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }

  saveGoal(t) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/ProgramResultsDetails",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(t)
      }).then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(st => {
            this.state.data.programResults.totalBilled = st.totalBilled;
            this.state.data.programResults.devolutionTotal = st.devolutionTotal
            this.state.data.programResults.consideredTotal = st.consideredTotal
            this.state.data.programResults.goalCropRetRule3 = st.goalCropRetRule3
            this.state.data.programResults.goalCropRetRuleGHE = st.goalCropRetRuleGHE
            this.state.data.programResults.metaRule = st.metaRule
            this.state.data.programResults.metaRule55 = st.metaRule55
            this.state.data.programResults.mainAward = st.mainAward
            this.state.data.programResults.mainAwardSC = st.mainAwardSC
            this.state.data.programResults.mainAwardSCRS = st.mainAwardSCRS
            this.state.data.programResults.teamAward = st.teamAward
            this.state.data.programResults.teamAwardSCRS = st.teamAwardSCRS
            this.state.data.programResults.description = st.description
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }
  
  changeStatus() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/ProgramResultsDetails/Status",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ programStatus: { keyConstant: this.state.nextstatus }, observation: typeof this.state.form.observation === "string" ? this.state.form.observation : null })
      }).then((response) => {
        if (response.ok && response.status == 200){
          this.setState({ modalLoading: null, isModalVisible: null });
          response.json().parse([]).then(t => this.setState({ modalLoading: false, isModalVisible: null, status: t }));
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      })
      .finally(() => {
        window.location.reload()
      });
    
  }

  removeResult(t) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/ProgramResultsDetails",
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(st => {
            this.setState({ modalLoading: false, isModalVisible: null });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  ValidateAcessPage(t) {
    if(t === 1 || t === 4 || t === 9 || t === 10 || t === 12 && Parsers.parsePermission2(["CUSTOMER_RESULT_CREATION", "CUSTOMER_RESULT_EDIT"])){
      if(t === 4 || t === 9 || t === 10 && Parsers.parsePermission2(["CUSTOMER_RESULT_APPROVE", "CUSTOMER_RESULT_DECLINE"])){
        return 1
      }
      else if (t === 12){
        return 1
      }else {
      return 0
      }
    }else {
      return 0
    } 
  }

  render() {
    return (
      <Container context={this.constructor}>
        {
          this.state.error != null && (this.ValidateAcessPage(this.state.status.programStatus.keyConstant) === 0) ? 
          <div>{Labels.GetLabel("results.notdataclient")}</div> 
          :
            this.state.loading ? 
            <div>{Labels.GetLabel("generic.loading")}</div> 
            :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> { this.state.data.program.brand.label + " - " + this.state.data.program.label }</span>
                    <div style={{ fontSize: 25 }}>{this.state.data.detail.name1 + (this.state.data.detail.name2 == null ? "" : this.state.data.detail.name2)
                      + (this.state.data.detail.name3 == null ? "" : this.state.data.detail.name3)
                      + (this.state.data.detail.name4 == null ? "" : this.state.data.detail.name4)}</div>
                    <div>{Labels.GetLabel("generic.docnumb")}: {this.state.data.detail == null ? Parsers.parseCPNJ(this.state.data.company.criticalValue) : this.state.data.detail.cnpjCode == null ? Parsers.parseCPNJ(this.state.data.detail.cpfCode) : Parsers.parseCPNJ(this.state.data.detail.cnpjCode)}</div>
                  </div>

                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(this.state.status.programStatus.keyConstant) }}>
                    <div className="generics_status_bar_title">
                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(this.state.status.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />
                      {Labels.GetLabel("PROGRAM_RESULTS_STATUS_REFUND." + this.state.status.programStatus.keyConstant)}
                    </div>
                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.status.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(this.state.status.datetimeRegister, "time")})</div>
                    <div className="generics_status_bar_desc">{Labels.GetLabel("PROGRAM_RESULTS_STATUS_DESC." + this.state.status.programStatus.keyConstant)}</div>
                    {
                      typeof this.state.status.observation === "string" && this.state.status.observation.length > 0 ?
                        <div className="generics_status_bar_desc">
                          <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel("generic.observation")}:</div>
                          {this.state.status.observation}
                        </div>
                        : null
                    }
                    {
                      Parsers.parsePermission2(["CUSTOMER_RESULT_APPROVE", "CUSTOMER_RESULT_DECLINE"]) && (this.state.status.programStatus.keyConstant === 4) ?

                        <div style={{ textAlign: "right", marginTop: 20 }}>
                          {
                            Parsers.parsePermission2(["CUSTOMER_RESULT_DECLINE"]) ?
                              <Button variant="danger" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 9 })}>
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_RESULT_B." + this.state.status.programStatus.keyConstant)}
                              </Button>
                              : null
                          }
                          {
                            Parsers.parsePermission2(["CUSTOMER_RESULT_APPROVE"]) ?
                              <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 10 })}>
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_RESULT_A." + this.state.status.programStatus.keyConstant)}
                              </Button>
                              : null
                          }
                        </div>
                        :
                      Parsers.parsePermission2(["CUSTOMER_RESULT_CREATION", "CUSTOMER_RESULT_EDIT"]) &&
                        (this.state.status.programStatus.keyConstant === 9 || 
                          this.state.status.programStatus.keyConstant === 10) ?
                        <div style={{ textAlign: "right", marginTop: 20 }}>
                          {
                            this.state.status.programStatus.keyConstant === 9 ?
                            <Button variant="success" style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 4 })}>
                              {Labels.GetLabel("REFUND_STATUS_PROGRAM_RESULT_A." + this.state.status.programStatus.keyConstant)}
                            </Button>
                              : null
                          }
                          {
                            this.state.status.programStatus.keyConstant === 10 ?
                            <Button variant="success" style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 12 })}>
                              {Labels.GetLabel("REFUND_STATUS_PROGRAM_RESULT_A." + this.state.status.programStatus.keyConstant)}
                            </Button>
                              : null
                          }
                        </div>
                        : null
                    }
                  </div>

                  <div style={{ padding: 20 }}>
                      <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_FRANCHISEE_listing3')}</div>
                      <InfoBox label={Labels.GetLabel("results.headcode")} 
                        value={this.state.data.programResults.headCompanyId}/>
                      <InfoBox label={Labels.GetLabel("results.clientcode")} 
                        value={this.state.data.programResults.mainCompanyId}/>

                      <div style={{ clear: "both" }}></div>
                      <InfoBox label={Labels.GetLabel("results.grossrevenue")} 
                        value={this.state.data.programResults.totalBilled + ' ' + Labels.GetLabel("results.sacks")}/>
                      <InfoBox label={Labels.GetLabel("results.returns")} 
                        value={this.state.data.programResults.devolutionTotal + ' ' + Labels.GetLabel("results.sacks")}/>
                      <InfoBox label={Labels.GetLabel("results.netrevenue")} 
                        value={this.state.data.programResults.consideredTotal + ' ' + Labels.GetLabel("results.sacks")}/>

                      <div style={{ clear: "both" }}></div>
                      <InfoBox label={Labels.GetLabel("results.harvestreturns")} 
                        value={this.state.data.programResults.goalCropRetRule3 + ' ' + Labels.GetLabel("results.sacks")}/>
                      <InfoBox label={Labels.GetLabel("results.harvestreturnsperc")} 
                        value={this.state.data.programResults.goalCropRetRuleGHE + ' %'}/>
                      <InfoBox label={Labels.GetLabel("results.metarule")} 
                        value={this.state.data.programResults.metaRule + ' ' + Labels.GetLabel("results.sacks")}/>

                      <div style={{ clear: "both" }}></div>
                      <InfoBox label={Labels.GetLabel("results.metarule2")} 
                        value={this.state.data.programResults.metaRule55 + ' %'}/>

                      <div style={{ clear: "both" }}></div>
                      {!this.state.data.programResults.mainAwardSCRS ? null 
                      :
                      <InfoBox label={Labels.GetLabel("results.mainprizeR$SC")} 
                        value={Parsers.parseMoney(this.state.data.programResults.mainAwardSCRS)}/>
                        }

                      {!this.state.data.programResults.teamAwardSCRS ? null 
                      :
                      <InfoBox label={Labels.GetLabel("results.salesequivprizeR$SC")} 
                        value={Parsers.parseMoney(this.state.data.programResults.teamAwardSCRS)}/>
                        }

                      <div style={{ clear: "both" }}></div>
                      {!this.state.data.programResults.mainAwardSC ? null 
                      :
                        <InfoBox label={Labels.GetLabel("results.mainprizeSC")} 
                          value={this.state.data.programResults.mainAwardSC + ' ' + Labels.GetLabel("results.sacks")}/>
                      }

                      <div style={{ clear: "both" }}></div>
                      {!this.state.data.programResults.mainAward ? null 
                      :
                      <InfoBox label={Labels.GetLabel("results.mainprizeR$")} 
                        value={Parsers.parseMoney(this.state.data.programResults.mainAward)}/>
                        }
                      

                      {!this.state.data.programResults.teamAward ? null 
                      :
                      <InfoBox label={Labels.GetLabel("results.salesteamaward")} 
                        value={Parsers.parseMoney(this.state.data.programResults.teamAward)}/>
                        }

                      <div style={{ clear: "both" }}></div>  
                      {!this.state.data.programResults.description ? null 
                      :
                        <InfoBox label={Labels.GetLabel("results.observation")} 
                        value={this.state.data.programResults.description}/>
                      }
                      <div style={{ clear: "both" }}></div>
                  </div>
                </div>
                <div className="generics_actionbar">
                  {!Parsers.parsePermission2(["GOAL_EDIT"]) ? null :
                    <DropdownButton disabled={this.state.status.programStatus.keyConstant == 12}
                      // as={ButtonGroup}
                      key="up"
                      drop="up"
                      variant="primary" style={{ marginRight: 10 }}
                      title={Labels.GetLabel("program.edit")}
                      onSelect={(t) => this.openModal(t)}
                    >
                      <Dropdown.Item eventKey="editResult" >
                        {Labels.GetLabel("program.editresult")}
                      </Dropdown.Item>
                    </DropdownButton>
                  }
                  <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("history")}>
                  {/* this.openModal("history" */}
                    {Labels.GetLabel("generic.history")}
                  </Button>
                  {
                    !Parsers.parsePermission2(["GOAL_EDIT"]) || !(this.state.status.programStatus.keyConstant === 1) ? null :
                    <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 4 })}>
                      {Labels.GetLabel("generic.gfvalidation")}
                    </Button>
                  }
                  {
                    !Parsers.parsePermission2(["GOAL_EDIT"]) || !(this.state.status.programStatus.keyConstant === 1) ? null :
                      <Button variant="danger" style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 12 })}>
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_RESULT_A.10")}
                      </Button>
                  }
                  
                  <div style={{ clear: "both" }}></div>
                </div>
                <Modal
                  className={this.state.modalLoading == true ? "modal-loading" : ""}
                  onHide={() => { }} show={this.state.isModalVisible != null} >
                  <div>
                    {
                      this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                        <div>
                          {Labels.GetLabel("adminstategroup.saving")}
                        </div>
                        :
                        this.state.isModalVisible == "editResult" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("program.resulttable")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <MaskedInput type="text" label={Labels.GetLabel("results.grossrevenue")} 
                                value={this.state.data.programResults.totalBilled}
                                onValid={(value) => this.updateForm("totalBilled", value)}
                                onInvalid={(value) => this.updateForm("totalBilled", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.returns")} 
                                value={this.state.data.programResults.devolutionTotal}
                                onValid={(value) => this.updateForm("devolutionTotal", value)}
                                onInvalid={(value) => this.updateForm("devolutionTotal", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.netrevenue")} 
                                value={this.state.data.programResults.consideredTotal}
                                onValid={(value) => this.updateForm("consideredTotal", value)}
                                onInvalid={(value) => this.updateForm("consideredTotal", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.harvestreturns")} 
                                value={this.state.data.programResults.goalCropRetRule3}
                                onValid={(value) => this.updateForm("goalCropRetRule3", value)}
                                onInvalid={(value) => this.updateForm("goalCropRetRule3", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.harvestreturnsperc")} 
                                value={this.state.data.programResults.goalCropRetRuleGHE}
                                onValid={(value) => this.updateForm("goalCropRetRuleGHE", value)}
                                onInvalid={(value) => this.updateForm("goalCropRetRuleGHE", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.metarule")} 
                                value={this.state.data.programResults.metaRule}
                                onValid={(value) => this.updateForm("metaRule", value)}
                                onInvalid={(value) => this.updateForm("metaRule", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.metarule2")} 
                                value={this.state.data.programResults.metaRule55}
                                onValid={(value) => this.updateForm("metaRule55", value)}
                                onInvalid={(value) => this.updateForm("metaRule55", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.mainprizeR$SC")} 
                                value={this.state.data.programResults.mainAwardSCRS}
                                onValid={(value) => this.updateForm("mainAwardSCRS", value)}
                                onInvalid={(value) => this.updateForm("mainAwardSCRS", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.salesequivprizeR$SC")} 
                                value={this.state.data.programResults.teamAwardSCRS}
                                onValid={(value) => this.updateForm("teamAwardSCRS", value)}
                                onInvalid={(value) => this.updateForm("teamAwardSCRS", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.mainprizeSC")} 
                                value={this.state.data.programResults.mainAwardSC}
                                onValid={(value) => this.updateForm("mainAwardSC", value)}
                                onInvalid={(value) => this.updateForm("mainAwardSC", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.mainprizeR$")} 
                                value={this.state.data.programResults.mainAward}
                                onValid={(value) => this.updateForm("mainAward", value)}
                                onInvalid={(value) => this.updateForm("mainAward", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.salesteamaward")} 
                                value={this.state.data.programResults.teamAward}
                                onValid={(value) => this.updateForm("teamAward", value)}
                                onInvalid={(value) => this.updateForm("teamAward", null)}
                                />
                              <MaskedInput type="text" label={Labels.GetLabel("results.observation")} 
                                value={this.state.data.programResults.description}
                                onValid={(value) => this.updateForm("description", value)}
                                onInvalid={(value) => this.updateForm("description", null)}
                              />
                            </Modal.Body>
                            <Modal.Footer style={{ flexDirection: "row" }}>
                              <Button variant="danger" onClick={() => this.removeResult()}>
                                    {Labels.GetLabel("generic.delete")}
                                  </Button>
                                  <div style={{ flex: 1 }}></div>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                              <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.saveGoal(this.state.form)}>
                                {Labels.GetLabel("adminstategroup.savebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                        : 
                        this.state.isModalVisible == "history" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("generic.history")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              {
                                this.state.data.programResults.programResultsStatus.map(t =>
                                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(t.programStatus.keyConstant) }}>
                                    <div className="generics_status_bar_title">
                                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(t.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />{Labels.GetLabel("PROGRAM_RESULTS_STATUS_REFUND." + t.programStatus.keyConstant)}
                                    </div>
                                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(t.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(t.datetimeRegister)})</div>
                                  </div>)
                              }
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                          :
                          this.state.isModalVisible == "changestatus" ?
                            <div>
                              <Modal.Header>
                                <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                {
                                  this.state.status.programStatus.keyConstant === 1 && this.state.nextstatus === 12? 
                                    Labels.GetLabel("PROGRAM_RESULTS_STATUS_WARNING." + (this.state.status.programStatus.keyConstant))
                                  : null
                                }
                                <br />
                                <br />
                                {Labels.GetLabel("PROGRAM_RESULTS_STATUS_WARNING." + (this.state.nextstatus))}
                                <br />
                                <br />
                                
                                {
                                  this.state.nextstatus == 9 ?
                                    <MaskedInput type="text" label={Labels.GetLabel("generic.observation")} notnull={true}
                                      onValid={(value) => this.updateForm("observation", (value))}
                                      onInvalid={(value) => this.updateForm("observation", null)} />
                                    : null
                                }
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="primary"
                                  disabled={!this.checkForm(this.state.form)}
                                  onClick={() => this.changeStatus()}>
                                  {Labels.GetLabel("generic.confirm")}
                                </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>
                            : 
                            null
                    }
                  </div>
                </Modal>
              </div>
        }
      </Container >
    );
  }
} 